(() => {
    'use strict';

    /* ------------------------------------------------------------------
     * Carousel block.
     *
     * Bootstrap wires carousels up from its data attributes exactly once, on
     * DOMContentLoaded. swup swaps the page without one, so a carousel that
     * arrives with a new page never gets an instance: the arrows do nothing and
     * it never advances. This builds one per block instead, and takes it apart
     * again when the page it belongs to leaves — the same contract as reveal and
     * lightbox, and for the same reason.
     *
     * It also decides autoplay. `data-bs-ride="carousel"` cycles regardless of
     * prefers-reduced-motion — Bootstrap drops the slide *transition* for a
     * visitor who asked for less motion but keeps moving them anyway, which is
     * the part that actually matters. Here, reduced motion means it waits to be
     * asked.
     * ---------------------------------------------------------------- */

    const stillness = window.matchMedia('(prefers-reduced-motion: reduce)');

    let instances = [];

    const destroy = () => {
        instances.forEach((instance) => {
            try {
                instance.dispose();
            } catch (e) {
                // Already gone with the page it was on. Nothing to undo.
            }
        });

        instances = [];
    };

    const init = () => {
        destroy();

        if (!window.bootstrap || !window.bootstrap.Carousel) {
            return;
        }

        document.querySelectorAll('[data-mb-carousel]').forEach((el) => {
            // The template only writes data-bs-ride when the editor asked for autoplay,
            // so its absence is a deliberate "off" rather than a missing default.
            const wanted = el.hasAttribute('data-bs-ride');
            const interval = parseInt(el.getAttribute('data-bs-interval'), 10);

            const instance = new window.bootstrap.Carousel(el, {
                interval: wanted && !stillness.matches && interval > 0 ? interval : false,
                ride: wanted && !stillness.matches ? 'carousel' : false,
                pause: 'hover',
                touch: true,
                wrap: true,
            });

            instances.push(instance);
        });
    };

    window.MB = window.MB || {};
    window.MB.carousel = { init, destroy };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
